// Brand: PizzaExpress
// Flow: PreOrder

import React from 'react';

import withAppState from '../../../mobx/withAppState';

import ContentPage from "../../../components/ContentPage"

const ContentPageWrapper = (props) => {
  const { refreshButtonLoading } = props;
  const showEatOutToHelpOutPage = props.showEatOutToHelpOutPage();
  if (!showEatOutToHelpOutPage) {
    props.useBufferedAction();
  }

  const render = (
    <div className="content-page">
      <p>You are eligible for the Government’s Discount Scheme, please ask a team member to apply your discount.</p>
      <p>Once your discount has been added, press ‘refresh’ on your bill to update the total</p>
      <button className={`btn btn-primary ${refreshButtonLoading ? 'disabled' : ''}`} onClick={props.refreshTable}>{refreshButtonLoading === false ? 'Refresh bill' : 'Refreshing'}</button>
    </div>
  )

  return <ContentPage render={render} />
}

export default withAppState(ContentPageWrapper,
  {
    mobXProps: ({
      refreshButtonLoading,
    }) => ({
      refreshButtonLoading,
    }),
    mobXActions: ({
      showEatOutToHelpOutPage,
      useBufferedAction,
      refreshTable,
    }) => ({
      showEatOutToHelpOutPage,
      useBufferedAction,
      refreshTable,
    })
  }
);